import React from 'react';
import { useTranslation } from 'react-i18next';
import { formSaveService } from '../../../services/formSaveService';
import SelectWithoutTokens from '../../../shared/SelectWithoutTokens';


const FormItemType = () => {
    const { i18n } = useTranslation();
    const changeFormType = (form) => {
        formSaveService.updateFormValue('formType', form.id);
    };
    const makeFormType = () => {
        return [
            {
                id: 'product-part',
                name: i18n.t(`product.scheme.formType.product-part`),
            },
        ];
    };
    const getFormTitle = (formType) => {
        if(formType) {
            return i18n.t(`product.scheme.formType.${formType}`);
        } else {
            return '';
        }
    };
    return (
        <label className="block__content product__form-label product__form-item" key={formSaveService.getForm().formType + 'label'}>
            <span className="block__text product__form-label_text">{i18n.t('app.page.product.addFormItem.formType')}</span>
            <SelectWithoutTokens
                listOfOptions={makeFormType()}
                handleChangeValue={changeFormType}
                titleValue={getFormTitle(formSaveService.getForm().formType)}/>
        </label>
    );
};

export default FormItemType;
